/* global google */
<template>
  <div>
    <DataParser />
  </div>
</template>

<script>
import DataParser from './components/DataParser.vue';

export default {
    components: {
      DataParser,
    }
}
</script>
